import React, { Component } from 'react'

import CheckIn from './UI/CheckIn'
import CheckOut from './UI/CheckOut'
import Form from './UI/Form'
import PartyComp from './UI/PartyComp'
import Rooms from './UI/Rooms'

class CheckInCheckOut extends Component {
  render () {
    return (
      <Form
        inline={this.props.inline}
      >
        <div>
          <CheckIn />
          <CheckOut />
          <PartyComp />
          <Rooms />
        </div>
      </Form>
    )
  }
}

CheckInCheckOut.defaultProps = {
  inline: false
}

export default CheckInCheckOut
